
import { Observable } from './druid/./druid/Observable';
import { _do } from './druid/./druid/operator/do';

Observable.prototype.do = _do;
Observable.prototype._do = _do;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    do: typeof _do;
    _do: typeof _do;
  }
}